<div class="app flex-row align-items-center bg-login">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="card-header bg-blue" style="font-size: 20px; color: #FFF;">
          <span><i class="fa s-icon-logIn"></i> ログイン</span>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <div class="card-body">
              <p class="text-muted mb-4">メールアドレスとパスワードを入力してください</p>
              @if (loginError) {
                <div class="alert alert-danger">メールアドレスまたはパスワードが正しくありません</div>
              }
              <form (ngSubmit)="login()" #loginForm="ngForm">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-login-input"><i class="fa s-icon-user text-white fa-fw"></i></span>
                  </div>
                  <input type="email" class="form-control" placeholder="メールアドレス"
                    [(ngModel)]="email" name="email" required email>
                </div>
                <div class="input-group mb-4">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-login-input"><i class="fa s-icon-passward text-white fa-fw"></i></span>
                  </div>
                  <input type="password" class="form-control" placeholder="パスワード"
                    [(ngModel)]="password" name="password" required autocomplete="off">
                </div>
                <div class="row">
                  <div class="col-6">
                    <a routerLink="/reset-password" class="btn btn-link px-0">
                      <i class="fa fa-question"></i> パスワードがわからない場合
                    </a>
                  </div>
                  <div class="col-6 text-right">
                    <button type="submit" class="btn btn-primary px-4 text-white"
                      [disabled]="loginForm.invalid || loading">ログイン</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
